import { StateProps } from 'Container/App/interface';
import {
    ADDITIONAL_PAGE_OPTIONS,
    SALESCHANNEL_CONSUMER,
    SALESCHANNEL_SOHO,
    SALESCHANNEL_YOUNG,
} from '@vfde-sails/constants';

/**
 * Prefetch possible redirection pages
 */
export const prefetchRedirectionPages = (customerConfig: NonNullable<StateProps['customerConfig']>): void => {
    const { offerSummaryCard, redirectionPages } = window[ADDITIONAL_PAGE_OPTIONS];

    if (
        !Object.keys(redirectionPages?.default || []).includes(customerConfig.salesChannel)
        || !Object.keys(redirectionPages?.gigakombi || []).includes(customerConfig.salesChannel)
    ) {
        // Nothing to redirect here
        return;
    }

    const pagesToPrefetch = [];

    const { gigakombi: gigakombiFlow, default: normalFlow } = redirectionPages;

    switch (true) {
        case (customerConfig.salesChannel === SALESCHANNEL_CONSUMER && !customerConfig.hasGigakombi):
            pagesToPrefetch.push(normalFlow[SALESCHANNEL_YOUNG]);
            pagesToPrefetch.push(gigakombiFlow[SALESCHANNEL_CONSUMER]);
            break;
        case (customerConfig.salesChannel === SALESCHANNEL_CONSUMER && customerConfig.hasGigakombi):
            pagesToPrefetch.push(gigakombiFlow[SALESCHANNEL_YOUNG]);
            pagesToPrefetch.push(normalFlow[SALESCHANNEL_CONSUMER]);
            break;
        case (customerConfig.salesChannel === SALESCHANNEL_YOUNG && !customerConfig.hasGigakombi):
            pagesToPrefetch.push(normalFlow[SALESCHANNEL_CONSUMER]);
            pagesToPrefetch.push(gigakombiFlow[SALESCHANNEL_YOUNG]);
            break;
        case (customerConfig.salesChannel === SALESCHANNEL_YOUNG && customerConfig.hasGigakombi):
            pagesToPrefetch.push(gigakombiFlow[SALESCHANNEL_CONSUMER]);
            pagesToPrefetch.push(normalFlow[SALESCHANNEL_YOUNG]);
            break;
        case (customerConfig.salesChannel === SALESCHANNEL_SOHO && !customerConfig.hasGigakombi):
            pagesToPrefetch.push(gigakombiFlow[SALESCHANNEL_SOHO]);
            break;
        case (customerConfig.salesChannel === SALESCHANNEL_SOHO && customerConfig.hasGigakombi):
            pagesToPrefetch.push(normalFlow[SALESCHANNEL_SOHO]);
            break;
    }

    // In case of gigakombi, also prefetch the gigakombi overlay content
    if (customerConfig.hasGigakombi) {
        pagesToPrefetch.push(offerSummaryCard.gigakombiOverlay);
    }

    for (const page of pagesToPrefetch) {
        const link = document.createElement('link');
        link.rel = 'prefetch';
        link.href = page;
        link.as = 'document';

        document.head.append(link);
    }
};
